// extracted by mini-css-extract-plugin
export default {"root":"ParcelCompact_root__yypGC","header":"ParcelCompact_header__W2Pf1","edit":"ParcelCompact_edit__jaVVw","type":"ParcelCompact_type__VoCZ0","image":"ParcelCompact_image__47sj-"};